import { Grid, Typography } from '@mui/material'

import imgMental from '../assets/04_case/01金屬零件業.png'
import imgPlastic from '../assets/04_case/02塑膠製品製造業.png'
import imgSemi from '../assets/04_case/03半導體設備零件製造業.png'
import { StyledPageTitle } from './CommonStyles'
import useRWD from '../utils/useRWD'

export default function Cases() {
  const {isToplet, isPC, isPhone} = useRWD()
  const imgList = [
    { alt: '金屬零件業', src: imgMental },
    { alt: '塑膠製品製造業', src: imgPlastic },
    { alt: '半導體設備零件製造業', src: imgSemi },
  ]
  return (
    <div >
      <StyledPageTitle variant="h3">應用案例</StyledPageTitle>
      <Grid container spacing={4}>
        {imgList.map((item, i) => (
          <Grid item xs={isPC ? 4 : 12} key={i}>
            <img src={item.src} alt={item.alt} style={{width: '100%'}}/>
          </Grid>
        ))}
      </Grid>
    </div>
  )
}
